<p-fieldset>
  <p-header class="article-title">
    <span class="article-title">{{ "ASSOCIATES-REPORTS" | translate }}</span>
    <div class="header-buttons"></div>
  </p-header>

  <div class="dialog-form">
    <div class="form-group">
      <div class="form-control">
        <label for="emUtilizacao">Utilização</label>
        <p-dropdown
          [options]="tilesInUse"
          name="emUtilizacao"
          appendTo="body"
          [(ngModel)]="filter.inUse"
        >
        </p-dropdown>
      </div>

      <div class="form-control">
        <label for="active">Títulos Ativos</label>
        <p-dropdown
          [options]="titlesActive"
          name="active"
          appendTo="body"
          [(ngModel)]="filter.active"
        >
        </p-dropdown>
      </div>

      <div class="form-control">
        <label for="titlePropertyType">Tipo de Título</label>
        <p-multiSelect
          [options]="titlesTypes"
          [(ngModel)]="filter.titlePropertyType"
          appendTo="body"
          selectedItemsLabel="{0} itens selecionados"
          name="groupsList"
        >
        </p-multiSelect>
      </div>

      <div class="form-control">
        <label for="titlePropertyType">Somente Bloqueados</label>
        <p-inputSwitch
          name="titlePropertyType"
          [(ngModel)]="filter.block"
        ></p-inputSwitch>
      </div>

      <div class="form-control">
        <label for="titlePropertyType">Exibir Dependentes</label>
        <p-inputSwitch
          name="titlePropertyType"
          [(ngModel)]="filter.showDependents"
        ></p-inputSwitch>
      </div>

      <div class="form-control">
        <label for="titlePropertyType">Ordenar por Nome </label>
        <p-inputSwitch
          name="titlePropertyType"
          [(ngModel)]="filter.orderName"
        ></p-inputSwitch>
      </div>
    </div>

    <div class="buttons">
      <div class="form-button">
        <button class="easymarine primary" (click)="find()" type="button">
          <i class="pi pi-search"></i>

          Exportar Relatório
        </button>
      </div>
    </div>
  </div>

</p-fieldset>
